import axios, { type AxiosInstance } from 'axios';

import { API_BASE_URL, API_TIMEOUT_MS, REQUEST_ID_HEADER } from './api.constant';
import { normalizeError } from './api-error';
import { createRequestId } from './request-id';

/**
 * 인증을 붙이지 않는 axios 인스턴스.
 * - 모든 실패를 `ApiError` 로 바꾼다
 * - 요청마다 `x-request-id` 를 싣는다
 * - 리프레시 쿠키가 오가도록 `withCredentials`
 * - 캐시를 두지 않는다(서버 상태 캐시는 TanStack Query 가 가진다)
 *
 * 부팅 · 토큰 갱신 · 로그아웃만 직접 쓴다. 그 밖에는 `api`(http-client)를 쓴다.
 */
export function createRawClient(): AxiosInstance {
  const instance = axios.create({
    baseURL: API_BASE_URL,
    timeout: API_TIMEOUT_MS,
    withCredentials: true,
    headers: { Accept: 'application/json' },
  });

  instance.interceptors.request.use((config) => {
    if (!config.headers.has(REQUEST_ID_HEADER)) {
      config.headers.set(REQUEST_ID_HEADER, createRequestId());
    }
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error: unknown) => Promise.reject(normalizeError(error)),
  );

  return instance;
}

export const rawClient = createRawClient();
